module.exports = __webpack_public_path__ + "static/media/video-4.af008af1.jpg";